<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年03月10日 16:01:48 +0800
 * @最后修改时间: 2022-03-07 14:18:10
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Claim\ClaimType\editClaimType.vue
 -->
<template>
  <ContentLayout
    :title="
      iSEdited
        ? $t('label_essweb_ClaimType_form_editTitle')
        : $t('label_essweb_ClaimType_form_viewTitle')
    "
    widthClass="max-1000"
    :editBtn="!iSEdited"
    :backgroundClass="curTab == 'tab-4' ? 'transparent pa-0' : ''"
    pad="0"
    :initData="ClaimTypeData"
    @change="(changed) => (isChanged = changed)"
    :checkData="[
      'claim_type_name',
      'claim_type_description',
      'claim_type_code',
      'claim_type_property_group_uuid',
    ]"
    @edit="iSEdited = true"
    delBtn
    @delete="
      $confirmDo($t('label_essweb_ClaimType_list_title')).then((res) => {
        res ? toDelete() : null;
      })
    "
  >
    <!-- content -->
    <template v-slot:page-main>
      <Taber
        :curTab="curTab"
        @change="(tab) => (curTab = tab)"
        :items="taber"
        :special="curTab == 'tab-4'"
        :contentBackground="curTab == 'tab-4' ? 'mrc-grey pa-0' : ''"
      >
        <template v-slot:content-1>
          <v-form ref="form" lazy-validation class="pa-2">
            <v-row class="white">
              <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                <inputTextFiledMultiLang
                  :filled="iSEdited"
                  maxlength="100"
                  :readonly="!iSEdited"
                  :bindData="ClaimTypeData.claim_type_name"
                  @change="
                    (valueArr) => {
                      ClaimTypeData.claim_type_name = valueArr;
                    }
                  "
                  :label="$t('label_essweb_ClaimType_form_claimTypeNameLabel')"
                  :rules="$GetRules(['_Require_Rules'], [null])"
              /></v-col>
              <v-col :md="iSEdited ? 3 : 6">
                <numberInputTextFiled
                  :filled="iSEdited"
                  maxlength="11"
                  :label="$t('label_essweb_ClaimType_form_sequenceLabel')"
                  :rules="
                    $GetRules(['_Number_negative', '_Length_Rules'], [null, 11])
                  "
                  v-model="ClaimTypeData.sequence"
                  :max="1000"
                  :min="0"
                  :placeholder="$t('label_essweb_ClaimType_form_sequenceLabel')"
                />
              </v-col>
              <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                <normalInputTextFiled
                  :filled="iSEdited"
                  :readonly="!iSEdited"
                  maxlength="100"
                  :label="$t('label_essweb_ClaimType_form_claimTypeCodeLabel')"
                  v-model="ClaimTypeData.claim_type_code"
                  :placeholder="
                    $t('label_essweb_ClaimType_form_claimTypeCodeLabel')
                  "
                />
              </v-col>
              <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                <v-sheet class="mrc_text_require text--secondary">{{
                  $t("label_essweb_ClaimType_form_claimTypePropertyGroupLabel")
                }}</v-sheet>
                <v-autocomplete
                  :items="ClaimTypePorpertyGroup"
                  :filled="iSEdited"
                  :readonly="!iSEdited"
                  item-text="claim_type_property_group_name"
                  item-value="uuid"
                  v-model="ClaimTypeData.claim_type_property_group_uuid"
                  :append-icon="iSEdited ? 'arrow_drop_down' : ''"
                  single-line
                  :rules="$GetRules(['_Require_ArrRules'], [null])"
                  :placeholder="
                    $t(
                      'label_essweb_ClaimType_form_claimTypePropertyGroupLabel'
                    )
                  "
                  dense
                >
                  <template v-slot:no-data> <noContent /> </template
                ></v-autocomplete>
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <inputTextFiledMultiLang
                  :filled="iSEdited"
                  :readonly="!iSEdited"
                  :bindData="ClaimTypeData.claim_type_description"
                  maxlength="500"
                  @change="
                    (valueArr) => {
                      ClaimTypeData.claim_type_description = valueArr;
                    }
                  "
                  :label="$t('label_essweb_ClaimType_form_descriptionLabel')"
              /></v-col> </v-row></v-form
        ></template>
        <template v-slot:content-2>
          <Tabler
            :headers="claimTypeTransactionHeaders"
            :items="claimTypeTransactions"
            border
            :showFooter="iSEdited"
            :avPerPage="50"
          >
            <template v-slot:item.name="{ item }">
              <div class="table-title text--primary">
                {{ $getCommonLangValue(item.claim_transaction_type_name) }}
              </div>
            </template>
            <template v-slot:item.code="{ item }">
              <div class="table-title text--primary">
                {{ item.claim_transaction_type_code }}
              </div>
            </template>
            <template v-slot:item.action="{ item }">
              <v-btn
                icon
                @click="
                  curTranTypeUuid = item.uuid;
                  showEditTranType = true;
                "
                v-if="!iSEdited"
              >
                <svg-icon
                  size="24"
                  fill="currentColor"
                  iconClass="viewDetail"
                />
              </v-btn>
              <v-btn
                icon
                small
                v-if="iSEdited"
                @click="
                  curTranTypeUuid = item.uuid;
                  showEditTranType = true;
                "
              >
                <span class="material-icons-round">edit</span>
              </v-btn>
              <v-btn
                icon
                small
                @click="toDeleteTransactionType(item.uuid)"
                v-if="iSEdited"
              >
                <span class="material-icons-round">delete</span>
              </v-btn>
            </template>
            <template v-slot:footer>
              <v-container fluid class="pa-0">
                <v-divider></v-divider>
                <v-btn
                  text
                  small
                  class="my-2 text-capitalize"
                  color="primary"
                  @click="showNewTranType = true"
                >
                  {{
                    $t(
                      "label_essweb_ClaimType_form_dialog_addClaimTypeTransactionTypeBtnLabel"
                    )
                  }}
                  <span class="material-icons-round">add</span>
                </v-btn>
              </v-container>
            </template>
          </Tabler>
        </template>
        <template v-slot:content-3>
          <Tabler
            :headers="ApprovalFlowHeaders"
            :items="ApprovalFlows"
            :showFooter="iSEdited"
            border
            :avPerPage="50"
          >
            <template v-slot:item.amount="{ item }">
              <div class="table-title text--primary">
                {{ item.operator }}{{ item.amount }}
              </div>
            </template>
            <template v-slot:item.name="{ item }">
              <div
                class="table-title text--primary"
                :title="$getCommonLangValue(item.flow_template_name)"
              >
                {{ $getCommonLangValue(item.flow_template_name) }}
              </div>
            </template>

            <template v-slot:item.action="{ item }">
              <v-btn
                icon
                @click="
                  curApprovalUuid = item.uuid;
                  showApprovalFlow = true;
                "
                v-if="!iSEdited"
              >
                <svg-icon
                  size="24"
                  fill="currentColor"
                  iconClass="viewDetail"
                />
              </v-btn>
              <v-btn
                icon
                small
                v-if="iSEdited"
                @click="
                  curApprovalUuid = item.uuid;
                  showApprovalFlow = true;
                "
              >
                <span class="material-icons-round">edit</span>
              </v-btn>
              <v-btn
                icon
                small
                @click="toDeleteApprovalFlow(item.uuid)"
                v-if="iSEdited"
              >
                <span class="material-icons-round">delete</span>
              </v-btn>
            </template>
            <template v-slot:footer>
              <v-container fluid class="pa-0">
                <v-divider></v-divider>
                <v-btn
                  text
                  small
                  class="my-2 text-capitalize"
                  color="primary"
                  @click="showNewApprovalFlow = true"
                >
                  {{
                    $t(
                      "label_essweb_ClaimType_form_dialog_addapprovalFlowBtnLabel"
                    )
                  }}
                  <span class="material-icons-round">add</span>
                </v-btn>
              </v-container>
            </template>
          </Tabler>
        </template>
        <template v-slot:content-4>
          <div class="max-width rounded-lg transparent">
            <v-tabs
              vertical
              v-model="lefttab"
              background-color="var(--taber-nav-color)"
              class="mrc-grey"
              hide-slider
            >
              <v-sheet height="8" width="200" class="rounded-t-lg"></v-sheet>
              <v-tab
                class="white text-capitalize px-3 mr-2 text-left text-truncate"
                style="width: 200px"
                :class="lefttab == 0 ? 'primary lighten-5 text--primary' : ''"
                ><div class="max-width text-left text-truncate">
                  {{ $t("label_essweb_ClaimType_form_tab_beforeNoticeLabel") }}
                </div></v-tab
              >
              <v-tab
                class="white text-capitalize px-3 mr-2 text-left text-truncate"
                style="width: 200px"
                :class="lefttab == 1 ? 'primary lighten-5 text--primary' : ''"
                ><div class="max-width text-left text-truncate">
                  {{ $t("label_essweb_ClaimType_form_tab_afterNoticeLabel") }}
                </div></v-tab
              >
              <v-sheet height="8" width="200" class="rounded-b-lg"></v-sheet>
              <v-tab-item class="mrc-grey rounded-lg">
                <v-card class="white" :elevation="0">
                  <v-card-text class="transparent pa-8">
                    <v-container fluid class="mrc-grey rounded-lg">
                      <!-- <draggable
              v-model="dragArr"
              draggable=".drag"
              v-bind="{ animation: 1000 }"
              :list="NoticeList"
            >-->
                      <v-sheet
                        class="rounded-lg pa-0 drag mt-2 mb-2"
                        v-for="(item, index) in beforeNoticeList"
                        :key="index"
                      >
                        <v-hover v-slot:default="{ hover }" open-delay="100">
                          <v-card
                            class="pa-2 d-flex rounded-lg align-center"
                            :elevation="hover ? 4 : 2"
                          >
                            <svg-icon
                              size="36"
                              fill="grey"
                              iconClass="dragvertical"
                              style="min-width: 36px"
                            />
                            <svg-icon
                              size="36"
                              fill="black"
                              iconClass="arrow01"
                              style="min-width: 36px"
                            />
                            <span class="text-body-2">
                              {{
                                $getCommonLangValue(
                                  item["claim_type_notice_point_" + item.number]
                                )
                              }}
                            </span>
                            <v-spacer></v-spacer>
                            <v-btn
                              icon
                              small
                              v-if="hover && iSEdited"
                              @click="toEditNotice(item, 'before')"
                            >
                              <span class="material-icons-round">edit</span>
                            </v-btn>
                            <v-btn
                              icon
                              small
                              v-if="hover && iSEdited"
                              @click="onDeleteNotice(item.number, 'before')"
                            >
                              <span class="material-icons-round">delete</span>
                            </v-btn>
                          </v-card>
                        </v-hover>
                      </v-sheet>
                      <!-- </draggable> -->
                    </v-container>
                    <v-form ref="form2" lazy-validation>
                      <v-row>
                        <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                          <v-checkbox
                            :disabled="!iSEdited"
                            v-model="before_is_required_acknowledgement"
                            :label="
                              $t(
                                'label_essweb_ClaimType_form_noticeRequireLabel'
                              )
                            "
                            required
                          ></v-checkbox>
                        </v-col>
                        <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                          <inputTextFiledMultiLang
                            :filled="iSEdited"
                            :readonly="!iSEdited"
                            maxlength="100"
                            :bindData="before_acknowledge"
                            @change="
                              (valueArr) => {
                                before_acknowledge = valueArr;
                              }
                            "
                            :label="
                              $t('label_essweb_ClaimType_form_acknowledgeLabel')
                            "
                          />
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-card-text> </v-card
              ></v-tab-item>
              <v-tab-item class="mrc-grey">
                <v-card class="white" :elevation="0">
                  <v-card-text class="transparent pa-8">
                    <v-container fluid class="mrc-grey rounded-lg">
                      <!-- <draggable
              v-model="dragArr"
              draggable=".drag"
              v-bind="{ animation: 1000 }"
              :list="NoticeList"
            >-->
                      <v-sheet
                        class="rounded-lg pa-0 drag mt-2 mb-2"
                        v-for="(item, index) in afterNoticeList"
                        :key="index"
                      >
                        <v-hover v-slot:default="{ hover }" open-delay="100">
                          <v-card
                            class="pa-2 d-flex rounded-lg align-center"
                            :elevation="hover ? 4 : 2"
                          >
                            <svg-icon
                              size="36"
                              fill="grey"
                              iconClass="dragvertical"
                              style="min-width: 36px"
                            />
                            <svg-icon
                              size="36"
                              fill="black"
                              iconClass="arrow01"
                              style="min-width: 36px"
                            />
                            <span class="text-body-2">
                              {{
                                $getCommonLangValue(
                                  item["claim_type_notice_point_" + item.number]
                                )
                              }}
                            </span>
                            <v-spacer></v-spacer>
                            <v-btn
                              icon
                              small
                              v-if="hover && iSEdited"
                              @click="toEditNotice(item, 'after')"
                            >
                              <span class="material-icons-round">edit</span>
                            </v-btn>
                            <v-btn
                              icon
                              small
                              v-if="hover && iSEdited"
                              @click="onDeleteNotice(item.number, 'after')"
                            >
                              <span class="material-icons-round">delete</span>
                            </v-btn>
                          </v-card>
                        </v-hover>
                      </v-sheet>
                      <!-- </draggable> -->
                    </v-container>
                    <v-form ref="form3" lazy-validation>
                      <v-row>
                        <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                          <v-checkbox
                            v-model="after_is_required_acknowledgement"
                            :disabled="!iSEdited"
                            :label="
                              $t(
                                'label_essweb_ClaimType_form_noticeRequireLabel'
                              )
                            "
                            required
                          ></v-checkbox>
                        </v-col>
                        <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                          <inputTextFiledMultiLang
                            :filled="iSEdited"
                            :readonly="!iSEdited"
                            :bindData="after_acknowledge"
                            :rules="$GetRules(['_Require_Rules'], [null])"
                            @change="
                              (valueArr) => {
                                after_acknowledge = valueArr;
                              }
                            "
                            :label="
                              $t('label_essweb_ClaimType_form_acknowledgeLabel')
                            "
                          />
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-card-text> </v-card
              ></v-tab-item>
            </v-tabs>
          </div>
        </template>
        <template v-slot:content-5>
          <Tabler
            :headers="claimTypeItemHeaders"
            :items="claimTypeItems"
            border
            :showFooter="iSEdited"
            :avPerPage="50"
          >
            <template v-slot:item.name="{ item }">
              <div class="table-title text--primary">
                {{ $getCommonLangValue(item.claim_item_type_name) }}
              </div>
            </template>
            <template v-slot:item.action="{ item }">
              <v-btn icon @click="toDeleteClaimItem(item.uuid)">
                <span class="material-icons-round">delete</span>
              </v-btn>
            </template>
            <template v-slot:footer>
              <v-container fluid class="pa-0">
                <v-divider></v-divider>
                <v-btn
                  text
                  small
                  class="my-2 text-capitalize"
                  color="primary"
                  @click="newClaimItemDialog = true"
                >
                  {{
                    $t(
                      "label_essweb_ClaimType_form_dialog_addClaimItemBtnLabel"
                    )
                  }}
                  <span class="material-icons-round">add</span>
                </v-btn>
              </v-container>
            </template>
          </Tabler>
        </template>
      </Taber>
    </template>
    <!-- actions -->
    <template v-slot:page-actions>
      <CardActions
        :style="{
          marginLeft: curTab == 'tab-4' ? '208px' : '0px',
          width: curTab == 'tab-4' ? 'calc(100% - 208px)' : '100%',
        }"
        :saveBtn="iSEdited && (curTab == 'tab-1' || curTab == 'tab-4')"
        @save="toSave"
        @cancel="$toBack(isChanged)"
        v-if="
          iSEdited &&
          curTab != 'tab-5' &&
          curTab != 'tab-3' &&
          curTab != 'tab-2'
        "
      />
    </template>
    <!-- actions -->
    <!-- tools -->
    <template v-slot:tools-main>
      <editClaimTransactionType
        :show="showEditTranType"
        @close="
          showEditTranType = false;
          curTranTypeUuid = null;
        "
        @onSave="onSaveTransactionType"
        :iSEdited="iSEdited"
        :curUuid="curTranTypeUuid"
      />
      <newClaimTransactionType
        :show="showNewTranType"
        @close="showNewTranType = false"
        @onNew="onNewTransactionType"
      />
      <editApprovalFlow
        :show="showApprovalFlow"
        @close="
          showApprovalFlow = false;
          curApprovalUuid = null;
        "
        @onSave="onSaveApprovalFlow"
        :iSEdited="iSEdited"
        :curUuid="curApprovalUuid"
      />
      <newApprovalFlow
        :show="showNewApprovalFlow"
        @close="showNewApprovalFlow = false"
        @onNew="onNewApprovalFlow"
      />
      <newNotice
        :show="showNewNotice"
        @close="
          showNewNotice = false;
          NoticePropertyData = null;
        "
        :PropertyData="NoticePropertyData"
        @onNew="onNewNotice"
      />
      <newClaimItem
        :show="newClaimItemDialog"
        @close="newClaimItemDialog = false"
        @onSave="onEditClaimItem"
        :PorpertyData="curSelectClaimItem"
      />
    </template>
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
import editClaimTransactionType from "@/Page/EssAdmin/Claim/ClaimType/components/editClaimTransactionType.vue";
import newClaimTransactionType from "@/Page/EssAdmin/Claim/ClaimType/components/newClaimTransactionType.vue";
import editApprovalFlow from "@/Page/EssAdmin/Claim/ClaimType/components/editApprovalFlow.vue";
import newApprovalFlow from "@/Page/EssAdmin/Claim/ClaimType/components/newApprovalFlow.vue";
import newNotice from "@/Page/EssAdmin/Claim/ClaimType/components/newNotice";
import newClaimItem from "@/Page/EssAdmin/Claim/ClaimType/components/newClaimItem";
import draggable from "vuedraggable";
export default {
  name: "newClaimType",
  components: {
    draggable,
    editClaimTransactionType,
    newClaimTransactionType,
    editApprovalFlow,
    newApprovalFlow,
    newNotice,
    newClaimItem,
  },
  computed: {
    ...mapGetters(["companyLang"]),
    ClaimTypePorpertyGroup() {
      return this.$getSelectTrans(
        this.ClaimTypePorpertyGroupData,
        "claim_type_property_group_name"
      );
    },
    // curSelectClaimItem() {
    //   const that = this;
    //   var arr = [];
    //   that.claimTypeItems.map((item) => {
    //     arr.push({
    //       claim_item_type_name: item["claim_item_type_name"],
    //       uuid: item["claim_item_type_uuid"],
    //     });
    //   });
    //   return arr;
    // },
  },
  data() {
    return {
      curTab: "tab-1",
      isChanged: false,
      taber: [
        "label_essweb_ClaimType_form_tag_GeneralLabel",
        "label_essweb_ClaimType_form_tag_claimTransactionTypeLabel",
        "label_essweb_ClaimType_form_tag_approvalFlowLabel",
        "label_essweb_ClaimType_form_tag_noticeLabel",
        "label_essweb_ClaimType_form_tag_claimItemLabel",
      ],
      lefttab: 0,
      curEditType: null,
      showNewNotice: false,
      curSelectClaimItem: [],
      newClaimItemDialog: false,
      willClearNotice: null,
      NoticePropertyData: null,
      iSEdited: true,
      showNewTranType: false,
      curTranTypeUuid: null,
      showEditTranType: false,
      ClaimTypePorpertyGroupData: [],
      claimTypeTransactionHeaders: [
        {
          text: "label_essweb_ClaimType_form_claimTypeTransactionTypeNameLabel",
          value: "name",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_ClaimType_form_claimTypeTransactionTypeCodeLabel",
          value: "code",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      ApprovalFlowHeaders: [
        {
          text: "label_essweb_ClaimType_form_approvalClaimAmountLabel",
          value: "amount",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_ClaimType_form_approvalClaimTemplateNameLabel",
          value: "name",
          align: "start",
          sortable: false,
        },

        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      claimTypeItemHeaders: [
        {
          text: "label_essweb_ClaimType_form_claimItemLabel",
          value: "name",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      claimTypeItems: [],
      after_uuid: null,
      before_uuid: null,
      claimTypeTransactions: [],
      ApprovalFlows: [],
      curApprovalUuid: null,
      showApprovalFlow: false,
      showNewApprovalFlow: false,
      afterNoticeList: [],
      after_is_required_acknowledgement: false,
      after_acknowledge: "",
      after_acknowledge_save: "",
      before_acknowledge_save: "",
      beforeNoticeList: [],
      before_is_required_acknowledgement: false,
      before_acknowledge: "",
      ClaimTypeData: {
        claim_type_name: "",
        claim_type_description: "",
        claim_type_code: "",
        claim_type_property_group_uuid: "",
      },
    };
  },
  watch: {
    curTab() {
      // 解决内部tab切换国际化失效的问题
      this.getClaimTypeBeforeNotice();
    },
    lefttab(val) {
      if (val == 1) this.getClaimTypeAfterNotice();
    },
    newClaimItemDialog() {
      const that = this;
      this.curSelectClaimItem = [];
      this.$Sleep(200).then(() => {
        that.claimTypeItems.map((item) => {
          that.curSelectClaimItem.push({
            claim_item_type_name: item["claim_item_type_name"],
            uuid: item["claim_item_type_uuid"],
          });
        });
      });
    },
  },
  mounted() {
    const that = this;
    this.beforeNoticeList = [];
    this.afterNoticeList = [];
    for (let i = 0; i < 5; i++) {
      let json = {};
      json["claim_type_notice_point_" + (i + 1)] = this.$transCommonLangKey(
        this.$getCommonLangKey(this.companyLang)
      );

      json["number"] = i + 1;
      let obj1 = JSON.parse(JSON.stringify(json)); //深拷贝
      this.beforeNoticeList.push(obj1);
      let obj2 = JSON.parse(JSON.stringify(json)); //深拷贝
      this.afterNoticeList.push(obj2);
    }
    this.getClaimTypePropertyGroup();
    // this.ClaimTypeData.claim_type_name = this.$getCommonLangKey(
    //   this.companyLang
    // );
    // this.ClaimTypeData.claim_type_description = this.$getCommonLangKey(
    //   this.companyLang
    // );
    this.getDetail();
    this.getClaimTransactionType();
    this.getClaimTypeApprovalCondition();
    this.getClaimTypeItem();
    // 改为切换tab时候
    // this.getClaimTypeBeforeNotice();
    // this.getClaimTypeAfterNotice();
  },
  methods: {
    toDeleteClaimItem: function (uuid) {
      const that = this;
      this.$confirmDo(
        this.$t("label_essweb_ClaimType_form_tag_claimItemLabel")
      ).then((res) => {
        if (res)
          that
            .$Request({
              method: "POST",
              table: "ess_clm_map_claim_type_claim_item_type",
              url: "/claim-type-mapping/delete/",
              data: { uuids: uuid },
            })
            .then((res) => {
              that.$showMessage({
                text: that.$t(
                  "message_essweb_ClaimType_form_deleteClaimItemSuccessLabel"
                ),
                type: "success",
              });
              that.claimTypeItems = that.claimTypeItems.filter(
                (ele) => ele.uuid !== uuid
              );
            });
      });
    },
    onEditClaimItem: function (select) {
      let uuids = [];
      select.map((item) => {
        uuids.push(item.uuid);
      });
      const that = this;
      that.newClaimItemDialog = false;
      this.$Request({
        method: "POST",
        table: "ess_clm_map_claim_type_claim_item_type",
        url: "/claim-type-mapping/update/",
        data: {
          claim_type_uuid: this.$route.params.id,
          claim_item_type_uuids: uuids.join(","),
        },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_ClaimType_form_updateClaimItemSuccessLabel"
          ),
          type: "success",
        });
        that.getClaimTypeItem();
      });
    },
    toDeleteTransactionType: function (uuid) {
      const that = this;
      this.$confirmDo(
        this.$t("label_essweb_ClaimType_form_tag_claimTransactionTypeLabel")
      ).then((res) => {
        if (res) {
          that
            .$Request({
              method: "POST",
              table: "ess_clm_claim_transaction_type",
              url: "/claim-transaction-type/delete/",
              data: { uuids: uuid },
            })
            .then((res) => {
              that.$showMessage({
                text: that.$t(
                  "message_essweb_ClaimType_form_deleteClaimTransTypeSuccessLabel"
                ),
                type: "success",
              });
              that.claimTypeTransactions = that.claimTypeTransactions.filter(
                (ele) => ele.uuid !== uuid
              );
            });
        }
      });
    },

    onSaveTransactionType: function (obj) {
      const that = this;
      that.showEditTranType = false;
      this.$Request({
        method: "POST",
        table: "ess_clm_claim_transaction_type",
        url: "/claim-transaction-type/update/",
        data: {
          uuid: obj.uuid,
          claim_transaction_type_name: this.$transCommonLangKey(
            obj.claim_transaction_type_name,
            obj.claim_transaction_type_name_save
          ),
          claim_transaction_type_description: this.$transCommonLangKey(
            obj.claim_transaction_type_description,
            obj.claim_transaction_type_description_save
          ),
          claim_transaction_type_code: obj.claim_transaction_type_code,
          sequence: obj.sequence,
          over_balance_approval_flow_template_uuid:
            obj.over_balance_approval_flow_template_uuid, //bj 2021-07-05
          calculation_method: obj.calculation_method,
          claim_transaction_type_property_group_uuid:
            obj.claim_transaction_type_property_group_uuid,
        },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_ClaimType_form_updateClaimTransTypeSuccessLabel"
          ),
          type: "success",
        });
        that.getClaimTransactionType();
      });
    },
    onNewTransactionType: function (obj) {
      const that = this;
      that.showNewTranType = false;
      this.$Request({
        method: "POST",
        table: "ess_clm_claim_transaction_type",
        url: "/claim-transaction-type/add/",
        data: {
          claim_type_uuid: this.$route.params.id,
          claim_transaction_type_name: this.$transCommonLangKey(
            obj.claim_transaction_type_name
          ),
          claim_transaction_type_description: this.$transCommonLangKey(
            obj.claim_transaction_type_description
          ),
          claim_transaction_type_code: obj.claim_transaction_type_code,
          sequence: obj.sequence,
          calculation_method: obj.calculation_method,
          over_balance_approval_flow_template_uuid:
            obj.over_balance_approval_flow_template_uuid, //bj 2021-07-05
          claim_transaction_type_property_group_uuid:
            obj.claim_transaction_type_property_group_uuid,
        },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_ClaimType_form_updateClaimTransTypeSuccessLabel"
          ),
          type: "success",
        });
        that.getClaimTransactionType();
      });
    },
    onSaveApprovalFlow: function (obj) {
      const that = this;
      that.showApprovalFlow = false;
      this.$Request({
        method: "POST",
        table: "ess_clm_claim_type_approval_condition",
        url: "/claim-type-approval-condition/update/",
        data: {
          uuid: obj.uuid,
          claim_type_uuid: this.$route.params.id,
          approval_flow_template_uuid: obj.approval_flow_template_uuid,
          amount: obj.amount,
        },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_ClaimType_form_updateApprovalFlowSuccessLabel"
          ),
          type: "success",
        });
        that.getClaimTypeApprovalCondition();
      });
    },
    onNewApprovalFlow: function (obj) {
      const that = this;
      that.showNewApprovalFlow = false;
      this.$Request({
        method: "POST",
        table: "ess_clm_claim_type_approval_condition",
        url: "/claim-type-approval-condition/add/",
        data: {
          claim_type_uuid: this.$route.params.id,
          approval_flow_template_uuid: obj.approval_flow_template_uuid,
          amount: obj.amount,
        },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_ClaimType_form_updateApprovalFlowSuccessLabel"
          ),
          type: "success",
        });
        that.getClaimTypeApprovalCondition();
      });
    },
    toEditNotice: function (obj, type) {
      this.curEditType = type;
      this.NoticePropertyData = obj;
      this.showNewNotice = true;
    },
    onDeleteNotice: function (number, type) {
      const that = this;
      this.willClearNotice = number;
      this.$confirmDo(
        this.$t("label_essweb_ClaimType_form_tag_noticeLabel")
      ).then((res) => {
        if (res) that.toClearNotice(type);
      });
    },
    toClearNotice: function (type) {
      const that = this;
      if (type === "before") {
        this.beforeNoticeList.map((item) => {
          if (item.number == that.willClearNotice) {
            item["claim_type_notice_point_" + that.willClearNotice] =
              that.$transCommonLangKey(
                that.$getCommonLangKey(that.companyLang),
                item[
                  "claim_type_notice_point_" + that.willClearNotice + "_save"
                ]
              );
          }
        });
      } else {
        this.afterNoticeList.map((item) => {
          if (item.number == that.willClearNotice) {
            item["claim_type_notice_point_" + that.willClearNotice] =
              that.$transCommonLangKey(
                that.$getCommonLangKey(that.companyLang),
                item[
                  "claim_type_notice_point_" + that.willClearNotice + "_save"
                ]
              );
          }
        });
      }
    },
    onNewNotice: function (notice, number) {
      this.NoticePropertyData = null;
      if (this.curEditType === "before") {
        this.beforeNoticeList.map((item) => {
          if (item.number == number) {
            item["claim_type_notice_point_" + number] =
              this.$transCommonLangKey(
                notice,
                item["claim_type_notice_point_" + number + "_save"]
              );
          }
        });
      } else {
        this.afterNoticeList.map((item) => {
          if (item.number == number) {
            item["claim_type_notice_point_" + number] =
              this.$transCommonLangKey(
                notice,
                item["claim_type_notice_point_" + number + "_save"]
              );
          }
        });
      }

      this.showNewNotice = false;
    },
    toDeleteApprovalFlow: function (uuid) {
      const that = this;
      this.$confirmDo(
        this.$t("label_essweb_ClaimType_form_tag_approvalFlowLabel")
      ).then((res) => {
        if (res) {
          that
            .$Request({
              method: "POST",
              table: "ess_clm_claim_type_approval_condition",
              url: "/claim-type-approval-condition/delete/",
              data: { uuids: uuid },
            })
            .then((res) => {
              that.$showMessage({
                text: that.$t(
                  "message_essweb_ClaimType_form_deleteApprovalFlowSuccessLabel"
                ),
                type: "success",
              });
              that.ApprovalFlows = that.ApprovalFlows.filter(
                (ele) => ele.uuid !== uuid
              );
            });
        }
      });
    },
    getClaimTypePropertyGroup: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_clm_claim_transaction_record",
        url: "/claim-type-property-group/get-list/",
      }).then((res) => {
        that.ClaimTypePorpertyGroupData = res.data;
      });
    },
    toNext: function () {
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }

      this.curStep = this.curStep + 1;
    },
    toSave: function () {
      const that = this;
      if (this.curTab == "tab-1") {
        if (!this.$refs["form"].validate()) {
          this.$showMessage({
            title: this.$t("message_essweb_form_textField_noticeTitle"),
            okText: this.$t("message_essweb_form_textField_fillInAgain"),
            text: this.$t("message_essweb_form_textField_notIncorrect_content"),
            type: "warning",
          });
          return false;
        }
        this.$Request({
          method: "POST",
          table: "ess_claim_claim_type",
          url: "/claim-type/update-claim-type-table/",
          data: {
            uuid: this.$route.params.id,
            claim_type_name: this.$transCommonLangKey(
              this.ClaimTypeData.claim_type_name,
              this.ClaimTypeData.claim_type_name_save
            ),
            claim_type_description: this.$transCommonLangKey(
              this.ClaimTypeData.claim_type_description,
              this.ClaimTypeData.claim_type_description_save
            ),
            claim_type_code: this.ClaimTypeData.claim_type_code,
            sequence: this.ClaimTypeData.sequence,
            claim_type_property_group_uuid:
              this.ClaimTypeData.claim_type_property_group_uuid,
          },
        }).then((res) => {
          that.$toBack(); //回到不能编辑状态
          that.$showMessage({
            text: that.$t(
              "message_essweb_ClaimType_form_updateClaimTypeSuccessLabel"
            ),
            type: "success",
          });
        });
      }
      if (this.curTab == "tab-4") {
        let url = "";
        let table = "";
        let data = {};

        if (this.lefttab == 0) {
          if (!this.$refs["form2"].validate()) {
            this.$showMessage({
              title: this.$t("message_essweb_form_textField_noticeTitle"),
              okText: this.$t("message_essweb_form_textField_fillInAgain"),
              text: this.$t(
                "message_essweb_form_textField_notIncorrect_content"
              ),
              type: "warning",
            });
            return false;
          }
          url = "/claim-type-before-notice/update/";
          table = "ess_clm_claim_type_before_notice";
          data = {
            uuid: this.before_uuid,
          };
          let ess_clm_claim_type_before_notice_save = JSON.parse(
            JSON.stringify(this.beforeNoticeList)
          );
          ess_clm_claim_type_before_notice_save.map((item) => {
            data["claim_type_notice_point_" + item.number] =
              item["claim_type_notice_point_" + item.number];
          });
          data["is_required_acknowledgement"] = this
            .before_is_required_acknowledgement
            ? 1
            : 0;
          data["acknowledge_content"] = this.$transCommonLangKey(
            this.before_acknowledge,
            this.before_acknowledge_save
          );
        } else {
          if (!this.$refs["form3"].validate()) {
            this.$showMessage({
              title: this.$t("message_essweb_form_textField_noticeTitle"),
              okText: this.$t("message_essweb_form_textField_fillInAgain"),
              text: this.$t(
                "message_essweb_form_textField_notIncorrect_content"
              ),
              type: "warning",
            });
            return false;
          }
          url = "/claim-type-after-notice/update/";
          table = "ess_clm_claim_type_after_notice";
          data = {
            uuid: this.after_uuid,
          };
          let ess_clm_claim_type_after_notice_save = JSON.parse(
            JSON.stringify(this.afterNoticeList)
          );
          ess_clm_claim_type_after_notice_save.map((item) => {
            data["claim_type_notice_point_" + item.number] =
              item["claim_type_notice_point_" + item.number];
          });
          data["is_required_acknowledgement"] = this
            .after_is_required_acknowledgement
            ? 1
            : 0;
          data["acknowledge_content"] = this.$transCommonLangKey(
            this.after_acknowledge,
            this.after_acknowledge_save
          );
        }

        this.$Request({
          method: "POST",
          table: table,
          url: url,
          data: data,
        }).then((res) => {
          that.$toBack(); //回到不能编辑状态
          that.$showMessage({
            text: that.$t(
              "message_essweb_ClaimType_form_updateClaimTermAConditionSuccessLabel"
            ),
            type: "success",
          });
        });
      }
    },
    toNewMapping: function () {
      const that = this;
      this.newFeildDialog = true;
    },
    toEditMapping: function (item) {
      const that = this;
      this.editFeildDialog = true;
      this.curMapping = null;
      this.curMapping = item;
    },
    toDeleteProperty: function (obj) {
      const that = this;
      this.showPGDelete = true;
      this.curPropertyObj = obj;
    },
    getDetail: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_claim_claim_type",
        url: "/claim-type/get-claim-type-details/",
        data: { uuid: this.$route.params.id },
      }).then((res) => {
        res.data["claim_type_name_save"] = res.data.claim_type_name;
        res.data.claim_type_name = that.$transOnLineCommonLangKey(
          that.companyLang,
          res.data.claim_type_name
        );
        res.data["claim_type_description_save"] =
          res.data.claim_type_description;
        res.data.claim_type_description = that.$transOnLineCommonLangKey(
          that.companyLang,
          res.data.claim_type_description
        );
        that.ClaimTypeData = res.data;
      });
    },
    getClaimTransactionType: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_clm_claim_transaction_type",
        url: "/claim-transaction-type/get-list/",
        data: { claim_type_uuid: this.$route.params.id },
      }).then((res) => {
        that.claimTypeTransactions = res.data;
      });
    },
    getClaimTypeApprovalCondition: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_clm_claim_transaction_type",
        url: "/claim-type-approval-condition/get-list/",
        data: { claim_type_uuid: this.$route.params.id },
      }).then((res) => {
        that.ApprovalFlows = res.data;
      });
    },
    getClaimTypeItem: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_clm_map_claim_type_claim_item_type",
        url: "/claim-type-mapping/get-list/",
        data: { claim_type_uuid: this.$route.params.id },
      }).then((res) => {
        that.claimTypeItems = res.data;
      });
    },
    getClaimTypeBeforeNotice: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_clm_claim_type_before_notice",
        url: "/claim-type-before-notice/get-list/",
        data: { claim_type_uuid: this.$route.params.id },
      }).then((res) => {
        that.before_acknowledge = that.$getCommonLangKey(that.companyLang);
        let data = {};
        if (res.data && res.data.length) {
          data = res.data[0];
          that.before_uuid = data.uuid;
          that.beforeNoticeList.map((item, index) => {
            item["claim_type_notice_point_" + (index + 1) + "_save"] =
              data["claim_type_notice_point_" + (index + 1)];
            item["claim_type_notice_point_" + (index + 1)] =
              data["claim_type_notice_point_" + (index + 1)];
          });
          that.before_is_required_acknowledgement =
            data["is_required_acknowledgement"];
          that.before_acknowledge_save = data["acknowledge_content"];
          that.before_acknowledge = that.$transOnLineCommonLangKey(
            that.companyLang,
            data["acknowledge_content"]
          );
        }
      });
    },
    getClaimTypeAfterNotice: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_clm_claim_type_before_notice",
        url: "/claim-type-after-notice/get-list/",
        data: { claim_type_uuid: this.$route.params.id },
      }).then((res) => {
        that.after_acknowledge = that.$getCommonLangKey(that.companyLang);
        let data = {};
        if (res.data && res.data.length) {
          data = res.data[0];
          that.after_uuid = data.uuid;
          that.afterNoticeList.map((item, index) => {
            item["claim_type_notice_point_" + (index + 1) + "_save"] =
              data["claim_type_notice_point_" + (index + 1)];
            item["claim_type_notice_point_" + (index + 1)] =
              data["claim_type_notice_point_" + (index + 1)];
          });
          that.after_is_required_acknowledgement =
            data["is_required_acknowledgement"];
          that.after_acknowledge_save = data["acknowledge_content"];
          that.after_acknowledge = that.$transOnLineCommonLangKey(
            that.companyLang,
            data["acknowledge_content"]
          );
        }
      });
    },
    toDelete: function (uuid) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_claim_claim_type",
        url: "/claim-type/delete-claim-type-table/",
        data: { uuids: this.$route.params.id },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_ClaimType_list_deleteClaimTypeSuccessLabel"
          ),
          type: "success",
        });
        that.$toBack();
        if (that.iSEdited) that.$toBack();
      });
    },
  },
};
</script>
